(function () {
  'use strict';

  function isoToFlag(iso) {
    if (!iso || iso.length !== 2) return '';
    return iso.split('').map(function (c) {
      return String.fromCodePoint(c.charCodeAt(0) + 127397);
    }).join('');
  }

  // Render all flag emoji spans
  document.querySelectorAll('[data-country-flag]').forEach(function (el) {
    el.textContent = isoToFlag(el.dataset.countryFlag);
  });

  // Country picker
  var trigger  = document.querySelector('[data-country-picker-trigger]');
  var dropdown = document.querySelector('[data-country-picker-dropdown]');
  var codeInput = document.getElementById('footer-country-code');
  var pickerForm = document.getElementById('FooterCountryForm');

  if (trigger && dropdown) {
    function openPicker() {
      dropdown.classList.remove('sp-hidden');
      trigger.setAttribute('aria-expanded', 'true');
      // Scroll selected item into view
      var selected = dropdown.querySelector('[aria-selected="true"] button');
      if (selected) selected.scrollIntoView({ block: 'nearest' });
    }

    function closePicker() {
      dropdown.classList.add('sp-hidden');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function () {
      dropdown.classList.contains('sp-hidden') ? openPicker() : closePicker();
    });

    dropdown.querySelectorAll('[data-country-iso]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (codeInput) codeInput.value = btn.dataset.countryIso;
        if (pickerForm) {
          var returnUrl = new URL(window.location.href);
          returnUrl.searchParams.set('oc', btn.dataset.countryIso);
          var returnInput = pickerForm.querySelector('input[name="return_to"]');
          if (!returnInput) {
            returnInput = document.createElement('input');
            returnInput.type = 'hidden';
            returnInput.name = 'return_to';
            pickerForm.appendChild(returnInput);
          }
          returnInput.value = returnUrl.pathname + returnUrl.search;
          pickerForm.submit();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
        closePicker();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePicker();
    });
  }

  // Fix Klaviyo radiogroup to use native radio inputs for accessibility
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      var radiogroup = document.querySelector('.footer-subscribe-form-holder [role="radiogroup"]');
      if (radiogroup) {
        radiogroup.removeAttribute('role');
        radiogroup.removeAttribute('aria-label');
        radiogroup.removeAttribute('aria-required');
        radiogroup.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          radio.removeAttribute('aria-hidden');
          radio.setAttribute('tabindex', '0');
        });
        radiogroup.querySelectorAll('label[role="radio"]').forEach(function (label) {
          label.removeAttribute('role');
          label.removeAttribute('aria-checked');
          label.removeAttribute('data-aria-checked-listener');
          label.setAttribute('tabindex', '-1');
        });
      }
      var fieldset = document.querySelector('.footer-subscribe-form-holder fieldset[aria-required="true"]');
      if (fieldset && !fieldset.hasAttribute('aria-label') && !fieldset.hasAttribute('aria-labelledby')) {
        fieldset.setAttribute('aria-label', 'Gender preference');
      }
    }, 1500);
  });
})();
